import Box from '@mui/material/Box';

import Logo from 'assets/logo.webp';

const CompanyLogo = () => {
	return (
		<Box sx={{ display: 'flex', justifyContent: 'center' }}>
			<Box sx={{ maxWidth: '70%' }} component="img" alt="Membercenter Logo" src={Logo} />
		</Box>
	);
};

export default CompanyLogo;
